import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../utils/BodyWrap";
import ContentDiv from "../utils/ContentDiv";
import GeneralLoader from "../GeneralLoader";
import SectionFooter from "../utils/SectionFooter";
import ReviewSearch from "./review-search/ReviewSearch";
import SectionBanner from "../utils/SectionBanner";
import ReviewPreview from "./ReviewPreview";

// CSS
import "../../css/reviews/review-page.css";
import "../../css/reviews/reviews-search.css";

// State
import { getTranslations } from "../../store/actions/translations";
import { getPastReviews } from "../../store/actions/reviews";

class PastReviews extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["reviews", "buttons", "review_registration_dialog"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	static userActions(store, props) {
		const promises = [];

		if (store !== null) {
			promises.push(getPastReviews());
		} else {
			promises.push(props.getPastReviews());
		}

		return promises;
	}

	componentWillMount() {
		// if (!this.props.pastReviews) {
		PastReviews.userActions(null, this.props);
		// }
	}

	componentDidMount() {
		if (!this.props.translations.pages[this.props.translationKey]) {
			PastReviews.initialAction(null, this.props);
		}
	}

	render() {
		const {
			translationsLoading,
			translations,
			pastReviewsIsLoading,
			pastReviews,
			search
		} = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							<div className="section section-2--main">
								{translationsLoading ? (
									<GeneralLoader />
								) : !!translations.pages[this.props.translationKey] ? (
									<ContentDiv>
										{translations.pages[this.props.translationKey].content}
									</ContentDiv>
								) : null}
							</div>
							{!translationsLoading && (
								<div className="section section-2--side">
									<SectionFooter href="/reviews/related">
										{translations.sections.reviews.view_my_reviews_link}
									</SectionFooter>
									<ReviewSearch types={["past"]} />
								</div>
							)}
						</div>
						{!translationsLoading && (
							<React.Fragment>
								<div className="section-row section-row--block">
									<div className="section-content pt0 pb0">
										<SectionBanner>
											{translations.sections.reviews.past_reviews_title}
										</SectionBanner>

										{pastReviewsIsLoading || search.inProgress ? (
											<GeneralLoader />
										) : (
												<div className="preview-area pt1">
													{pastReviews.length ? (
														pastReviews.map((review, i) => (
															<ReviewPreview key={i} review={review} />
														))
													) : (
															<div>
																{
																	translations.sections.reviews
																		.no_past_reviews_response
																}
															</div>
														)}
												</div>
											)}
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		pastReviewsIsLoading:
			state.reviews.pastIsLoading !== undefined ? state.reviews.pastIsLoading : 1,
		pastReviews: state.reviews.pastReviews,
		search: state.reviewSearch
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getPastReviews }
)(PastReviews);



// WEBPACK FOOTER //
// ./src/components/reviews/PastReviews.js